import { privateAxios } from 'services/api/privateAxios';

export const addAddress = data =>
  privateAxios({
    method: 'post',
    url: `/address`,
    data,
  });
